import { render, staticRenderFns } from "./MetricBox.vue?vue&type=template&id=5406aaa7&scoped=true&"
import script from "./MetricBox.vue?vue&type=script&lang=ts&"
export * from "./MetricBox.vue?vue&type=script&lang=ts&"
import style0 from "./MetricBox.vue?vue&type=style&index=0&id=5406aaa7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5406aaa7",
  null
  
)

export default component.exports